import { render, staticRenderFns } from "./Categoires.vue?vue&type=template&id=32d7bc98&scoped=true"
import script from "./Categoires.vue?vue&type=script&lang=js"
export * from "./Categoires.vue?vue&type=script&lang=js"
import style0 from "./Categoires.vue?vue&type=style&index=0&id=32d7bc98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d7bc98",
  null
  
)

export default component.exports